module.exports = __webpack_public_path__ + "media/top/main_visual_features_sp-c0fad1d6.svg";